// extracted by mini-css-extract-plugin
export default {"container":"d--z","productName":"e--z","price":"f--z","dimensions":"g--z"};